'use client'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

export type FormSchema<T extends z.ZodSchema> = z.infer<T>

export const useAppForm = ({
  formSchema,
  defaultValues,
}: {
  formSchema: z.ZodSchema
  defaultValues?: z.infer<typeof formSchema>
}) => {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues,
  })

  return { form }
}
